import themeConfig from "./themes.json";
import { buildEdgenUnoColorPipeline } from "./edgenThemeColorPipeline";

const { themeColors } = buildEdgenUnoColorPipeline(themeConfig.colors);

/** 运行时主题色（全部为 `var(--edgen-*)`） */
export class OspThemes {
  get colors() {
    return themeColors;
  }
}

export const ospThemes = new OspThemes();
